import React from "react";
import { Link } from "react-router-dom";
function LandingPage() {
  return (
    <div className="w-full h-screen bg-[url('/public/images/background-landing.png')] bg-no-repeat bg-cover grid grid-cols-12 font-noto-sans-thai">
      <div className=" col-span-10 md:col-span-6 col-start-2 md:col-start-4 inline-flex flex-col justify-center gap-10 w-full items-center">
        <img
          src="/images/logo-bar.svg"
          alt="logo-bar"
          className="w-[198px] h-[72px] mx-auto"
        />
        <p className="text-base font-normal leading-6 text-text-primary text-center">
          {`ติดตามสถานะจุดความร้อนแบบ near
          real-time และแสดงข้อมูลจุดความร้อนบนแผนที่
          เพื่อสืบค้นข้อมูลตามพื้นที่ต้องการและสามารถ Monitoring
          ข้อมูลและแผนที่ได้`}
        </p>
        <div className="flex w-full flex-col items-center gap-4 justify-center">
          <Link
            to={`/register`}
            className="h-10 text-center w-full md:w-[420px] px-10 py-2 bg-primary-main hover:bg-opacity-70 text-primary-contrast text-sm leading-[22px] font-normal rounded-xl"
          >
            ลงทะเบียน
          </Link>
          <Link
            to={`/login`}
            className="h-10  text-center w-full md:w-[420px] px-10 py-2 bg-primary-contrast text-text-primary border-[1px] border-gray-2 hover:border-primary-main text-sm leading-[22px] font-normal rounded-xl"
          >
            เข้าสู่ระบบ
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
